/**
 * Localization settings
 */

import { UI_TO_CMS_MAP } from "../../../../../common/cms/cmsLanguageConstants";

export interface LanguageOption {
    id: string;
    name: string;
}

/**
 * Available app language options for the user interface
 */
export const getAppLanguageOptions = (): LanguageOption[] => [
    { id: UI_TO_CMS_MAP.en, name: 'English' },
    { id: UI_TO_CMS_MAP.es, name: 'Español (Spanish)' },
];

export const SUPPORTED_APP_LANGUAGE_CODES = Object.keys(UI_TO_CMS_MAP) as (
    keyof typeof UI_TO_CMS_MAP
)[];

export const DEFAULT_APP_LANGUAGE_CODE = SUPPORTED_APP_LANGUAGE_CODES[0];
